import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

const CountResolutionForm = ({
	resolutionText,
	setResolutionText,
	resolutionCount,
	setResolutionCount,
	resolutionYear,
}) => {
	const { t } = useLanguage();
	return (
		<>
			<div className='mb-4'>
				<label className='block text-sm font-medium text-gray-700 mb-1'>{t('resolutionText')}</label>
				<input
					type='text'
					value={resolutionText}
					onChange={(e) => setResolutionText(e.target.value)}
					className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
					required
				/>
			</div>

			<div className='mb-4'>
				<label className='block text-sm font-medium text-gray-700 mb-1'>{t('count')}</label>
				<input
					type='number'
					value={resolutionCount}
					onChange={(e) => setResolutionCount(e.target.value)}
					className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
					min='1'
				/>
			</div>

			<div className='mb-4'>
				<label className='block text-sm font-medium text-gray-700 mb-1'>{t('year')}</label>
				<input
					type='number'
					value={resolutionYear}
					className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm bg-gray-100'
					required
					disabled
				/>
			</div>
		</>
	);
};

export default CountResolutionForm;
